import { toneFor } from '../../components/ui/ChoiceCard.tsx';

/** A member told apart by a stable tone and an initial; the app's pixel sprites stay in the app. */
export function Avatar({ name, size = 'md' }: { name: string; size?: 'sm' | 'md' | 'lg' }) {
  const cls = size === 'sm' ? 'size-6 text-2xs' : size === 'lg' ? 'size-12 text-base' : 'size-9 text-xs';
  return (
    <span className={`avatar ${cls}`} data-tone={toneFor(name)} title={name} aria-label={name}>
      {name.slice(0, 2).toUpperCase()}
    </span>
  );
}
